import { useState, useEffect } from 'react';

interface GeolocationState {
  latitude: number | null;
  longitude: number | null;
  city: string | null;
  error: string | null;
  loading: boolean;
}

export const useGeolocation = () => {
  const [state, setState] = useState<GeolocationState>({
    latitude: null,
    longitude: null,
    city: null,
    error: null,
    loading: true
  });

  useEffect(() => {
    const getCityFromCoords = async (latitude: number, longitude: number) => {
      try {
        const response = await fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );
        const data = await response.json();
        return data.city || null;
      } catch (error) {
        console.error('Error getting city name:', error);
        return null;
      }
    };

    const getLocation = () => {
      if (!navigator.geolocation) {
        setState(prev => ({
          ...prev,
          error: 'Geolocation is not supported by your browser',
          loading: false
        }));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const city = await getCityFromCoords(
            position.coords.latitude,
            position.coords.longitude
          );
          
          setState({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            city,
            error: null,
            loading: false
          });
        },
        (error) => {
          setState(prev => ({
            ...prev,
            error: error.message,
            loading: false
          }));
        }
      );
    };

    getLocation();
  }, []);

  return state;
};